<template>
  <!-- 学生进步排名 -->
  <div class="stuAdvanceRank">
    <div class="pk-top">
      <p class="title"><span>屏3：学员进步排名</span></p>
      <div class="pk-top-right">
        <el-date-picker v-model="time_select" :picker-options="pickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" @change="timeChange()">
        </el-date-picker>
        <p class="small">*数据每十秒更新一次</p>
      </div>
    </div>
    <div class="main-box" v-show="tableData.length>0">
      <div class="topChart">
        <div>
          <ul v-if="stuAdvanceRankData.length>3">
            <li v-for="(item,index) in stuAdvanceRankData" :key="index" v-show='index<3'>
              <div class="list">
                <h5>{{item.xsxm}}</h5>
                <div>
                  <p>当天所有课次词汇量</p>
                  <p>{{item.dqzchl?item.dqzchl:0}}</p>
                </div>
                <div>
                  <p>前一天所有课次词汇量</p>
                  <p>{{item.qykcchl?item.qykcchl:0}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottomChart">
        <el-table :data="tableData" height="calc(100% - 90px)" :row-style="tableRowStyle">
          <el-table-column type="index" label="排名" :index="indexMethod">
          </el-table-column>
          <el-table-column property="xsxm" label="姓名">
          </el-table-column>
          <el-table-column property="dqzchl" label="当天所有课次词汇量">
            <template slot-scope="scope">
              <span>{{scope.row.dqzchl?scope.row.dqzchl:0}}</span>
            </template>
          </el-table-column>
          <el-table-column property="qykcchl" label="前一天所有课次词汇量">
            <template slot-scope="scope">
              <span>{{scope.row.qykcchl?scope.row.qykcchl:0}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="tea-pagination">
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="empty">
      <el-empty description="暂无数据" v-show="tableData.length==0"></el-empty>
    </div>
  </div>
</template>

<script>
import { screenStudentProgressRankingApi } from '@/api/teacher.js'

export default {
  name: 'finishStat',
  data() {
    return {
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: this.$route.query.bjid,
        bjmc: this.$route.query.bjmc,
      },
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],

      stuAdvanceRankData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
      },
      // 日期的选择
      time_select: null,//当前时间
      time_section: [],//可选择时间区间
      jxTime: {}, // 集训有效期
    }
  },
  created() {
    const time_options = JSON.parse(this.$route.query.time)
    this.time_section = [time_options.yxqq, time_options.yxqz];
    this.time_select =time_options.now_select;
    this.jxTime = JSON.parse(decodeURIComponent(this.$route.query.timeFirst));
  },
  mounted() {
    this.getStudentProgressList()
    this.setTimer()
  },
  distroyed: function () {
    clearInterval(this.setTimer())
  },
  methods: {
    // 日期禁选
    dealDisabledDate(time) {
      let start = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (end > now) {
        end = now
      }
      return time < start || time > end
    },
    timeChange() {
      this.handelSearch()
    },
    getStudentProgressList() {
      const data = this.search_data;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      data.qryDate = this.time_select;
      data.jxStartTime = this.jxTime.yxqq
      data.jxEndTime = this.jxTime.yxqz
      screenStudentProgressRankingApi(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          if (this.pages.currentPage == 1) {
            if (this.tableData.length > 2)
              this.stuAdvanceRankData = this.tableData
          }
        }
      })
    },
    setTimer: function () {
      this.timer = setInterval(() => {
        this.handelSearch()
      }, 10000)
    },
    // 排名计算
    indexMethod(index) {
      return (this.pages.currentPage - 1) * this.pages.pageSize + index + 1;
    },
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return { 'background-color': '#E1F4FF' }
      }
    },
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getStudentProgressList()
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.handelSearch()
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.getStudentProgressList()
    },

  }
}
</script>
<style lang="scss" scope>
.tea-pagination {
  margin-top: 15px;
}
.stuAdvanceRank {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  .pk-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .pk-top-right {
      display: flex;
      align-items: center;
    }
    .small {
      text-align: right;
      font-size: 12px;
      margin: 20px;
      color: red;
    }
    .title {
      span {
        background: #309bff;
        padding: 5px 20px;
        color: #fff;
        border-radius: 18px;
      }
    }
  }
  .main-box {
    // background-color: red;
    width: 100%;
    height: calc(100% - 60px);
  }
  .topChart {
    padding: 0 20px;
    overflow: hidden;
    ul {
      overflow: hidden;
      width: 100%;
      min-width: 1200px;
      li {
        float: left;
        width: 33.33%;
        list-style: none;
        .list {
          background: url(../../../assets/images/teacher/redBackground.png);
          width: 377px;
          height: 203px;
          h5 {
            height: 100px;
            line-height: 76px;
            padding-top: 24px;
            text-indent: 20px;
            font-size: 36px;
            margin: 0;
            color: #fff;
          }
          div {
            width: 50%;
            height: 100px;
            float: left;
            padding-left: 30px;
            p {
              font-size: 14px;
              margin: 0px;
              line-height: 40px;
              color: #fff;
              &:nth-child(2) {
                line-height: 40px;
                font-size: 28px;
              }
            }
          }
        }
        &:nth-child(2) {
          .list {
            background: url(../../../assets/images/teacher/blueBackground.png);
          }
        }
        &:nth-child(3) {
          .list {
            background: url(../../../assets/images/teacher/greenBackground.png);
          }
        }
      }
    }
  }
  .bottomChart {
    height: calc(100% - 180px);
    margin-top: 10px;
  }
  padding-top: 20px;
  ::v-deep  .el-table {
    margin: 20px auto 0;
    padding: 0 20px;
    .el-table__header {
      .has-gutter {
        th {
          background-color: #eee;
        }
      }
    }
    .el-table__body tr.el-table__row--striped td {
      background: #e1f4ff;
    }
  }
}
.empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>